import { render, staticRenderFns } from "./AffiliateProgramForm.vue?vue&type=template&id=4a8769a3&scoped=true&"
import script from "./AffiliateProgramForm.vue?vue&type=script&lang=js&"
export * from "./AffiliateProgramForm.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateProgramForm.vue?vue&type=style&index=0&id=4a8769a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8769a3",
  null
  
)

component.options.__file = "AffiliateProgramForm.vue"
export default component.exports